<template>
    <div class="entity-page-component">
        <div class="tool-bar" >
            <div>
                <v-btn  flat icon light :to="backLink" active-class  ><v-icon>arrow_back</v-icon></v-btn>
                <span class="title">{{ $t("message.Back") }}</span>
            </div>
            <div>
                <v-btn flat icon light v-on:click="save"><v-icon>done</v-icon></v-btn>
            </div>
        </div>

        <div class="entity-page" :style="{ 'min-height': computedPageHeight}">
            <div class="header">
               <v-icon large >business</v-icon>
                <div class="fullname" >{{ entityName }}</div> 
            </div>
            <v-tabs slider-color="secondary" class="app-tabs">
                <v-tab ripple>General</v-tab>
                <v-tab-item>
                    <v-text-field v-model="entityName" :label="$t('message.Name')"></v-text-field>
                    
                     <v-menu ref="colorMenu" :close-on-content-click="false" v-model="colorMenu" :nudge-right="40" lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="200px">
                        <v-text-field slot="activator" v-model="entityColor" :label="$t('message.Color')"  readonly >
                          <v-icon slot="prepend" :style="{ color: entityColor }" >lens</v-icon>
                        </v-text-field>
                        <chrome-picker v-model="colors" @input="changeColor" ></chrome-picker> 
                    </v-menu>
                </v-tab-item>
            </v-tabs> 
        </div>
        <v-snackbar
            v-model="showmessage"
            bottom="bottom"
            right="right"
            :timeout="6000"
            >
            <span>{{ alertMessage }}</span>
            <v-btn v-on:click="showmessage = false" flat icon dark><v-icon>close</v-icon></v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import GenericRepository from "../../services/GenericRepository.js";
import StatusRepository from "../../services/StatusRepository.js";
import HAL from "../../helpers/HAL.js";
import { Chrome } from 'vue-color'

export default {
  name: "StatusPage",
  components: {
    'chrome-picker': Chrome
   },
  computed: {
    computedPageHeight: function() {
      return this.pageHeight + "px";
    }
  },
  data() {
    return {
      pageHeight: 10,
      entityName: "",
      entityColor: "",
      statusId: null,
      updateLink: null,
      insertLink: "/api/statuses",
      backLink: "/status-list",
      showmessage: false,
      alertMessage: '',
      colorMenu: false,
      colors: '#ff0000'
    };
  },
  methods: {
    changeColor(value) {
      if(value) {
        this.entityColor = value.hex;
      }
    },
    goBack() {
      return "/status-list";
    },
    save() {
      var entity = {
        statusId: this.statusId,
        color: this.entityColor,
        name: this.entityName
      };
      if (entity.statusId > 0) {
        GenericRepository.update(this.updateLink.href, entity).then(
          function(response) {
            if (response.data && response.data.status == "Success") {
              window.vm.$router.push(this.goBack());
              this.$emit("save");
            }
            else {
                this.alertMessage = response.data.message;
                this.showmessage = true;
            }
          }.bind(this)
        );
      } else {
        GenericRepository.insert(this.insertLink, entity).then(
          function(response) {
            if (response.data && response.data.status == "Success") {
              window.vm.$router.push(this.goBack());
              this.$emit("save");
            }
            else {
                this.alertMessage = response.data.message;
                this.showmessage = true;
            }
          }.bind(this)
        );
      }
    }
  },
  created() {
    this.pageHeight = window.innerHeight - 57 - 25 - 25;
    if (!isNaN(this.$route.params.id)) {
      StatusRepository.getByID(this.$route.params.id).then(
        function(response) {
          if (response.data && response.data.status == "Success") {
            this.entityName = response.data.name;
            this.entityColor = response.data.color;
            this.colors = response.data.color;
            this.statusId = response.data.statusId;
            this.updateLink = HAL.getLink(response.data, "help:status-update");
          }
        }.bind(this)
      );
    }
  }
};
</script>

<style lang="stylus">
@import '../../assets/css/tool-bar.css';
@import '../../assets/css/entity-page.css';
</style>


